import { Label } from '@talentmesh/core';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/semantic-ui.css';
import useTMTranslation from '../../../../../../../Hooks/useTMTranslation';
import { PhoneBox } from './PhoneBox';
import { PhoneHelperText } from './PhoneHelperText';

interface PhoneNumberFieldProps {
    name: string;
    label: string;
}

const PhoneNumberField = ({ label, name }: PhoneNumberFieldProps) => {
    const { control } = useFormContext();
    const {
        field,
        fieldState: { error },
    } = useController({ control, name });
    const { tCommon: t } = useTMTranslation();

    return (
        <PhoneBox hasError={!!error?.message}>
            <Label>{label}</Label>
            <PhoneInput
                searchPlaceholder={t('Search')}
                country="us"
                value={field.value}
                onBlur={field.onBlur}
                onChange={(phone) => {
                    field.onChange(phone.length > 0 ? `+${phone}` : '');
                }}
                enableSearch
            />
            <PhoneHelperText errorMessage={error?.message} />
        </PhoneBox>
    );
};
export default PhoneNumberField;
